import React from 'react';
import { Alert } from '@components/Alert';
import LoadingTruck from '@components/Loading/LoadingTruck';
import routes from '@config/routes';
import { useAuth } from '@hooks/useAuth';
import { useVendor } from 'context/VendorContext';
import first from 'lodash/first';
import { useRouter } from 'next/router';
import { getDashboardRoutePath } from 'utils/routes-util';

import { useApp } from '../../context/AppContext/index';

export default function DashboardRedirect() {
  const {
    vendor: { nameId },
  } = useVendor();
  const router = useRouter();
  const { isLoading } = useAuth();
  const { user, userIsLoading } = useApp();
  const firstProfile = first(user?.profiles)?.nameId;
  const organizationNameId =
    nameId ?? user.defaultVendorId ?? first(user.profiles)?.nameId;

  if (userIsLoading || isLoading) {
    return <LoadingTruck />;
  }

  if (!user) {
    return <Alert type="error">User not found</Alert>;
  }

  if (!nameId && !user?.defaultVendorId && !firstProfile) {
    router.replace(
      `${routes.dashboard.add}?organizationId=${user.organizationId}`
    );
    return null;
  }

  if (organizationNameId) {
    router.replace(
      getDashboardRoutePath(routes.dashboard.overview, organizationNameId)
    );
  }

  return <></>;
}
